<template>
  <div class="content-wrapper">
    <div class="card p-2">
      <main>
        <div v-if="loadingData" class="d-flex justify-content-center my-3">
          <div class="spinner-border text-custom-blue">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div v-if="!loadingData">
          <div>
            <b-container>
              <b-row class="align-items-center mb-3">
                <b-col class="p-0">
                  <h4>Minha Carteira de Vacinação</h4>
                </b-col>
                <b-col cols="12" md="auto" class="d-flex justify-content-md-end mt-1 mt-md-0">
                  <b-button variant="outline-danger" @click="logout">
                    <feather-icon icon="LogOutIcon" class="mr-50" size="16" />
                    Sair
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </div>
          <CarteiraVacinacaoTableSimple
            table-id="tableCarteiraColaborador"
            :filtering="filtering"
            :table="table"
            :without-results="withoutResults"
            :loading-vaccination-card="loadingVaccinationCard"
            @view-card="viewVaccinationCard"
            @generate-card="generateVaccinationCard"
          />
        </div>
      </main>
    </div>

    <CarteiraVacinacaoModal
      modal-id="modal-view-carteira-colaborador"
      title="Carteira de Vacinação Colaborador"
      :show.sync="showModalView"
      :loading-modal="loadingModal"
      :loading-download="loadingDownload"
      :html-content="htmlContent"
      @download="downloadVaccinationCard"
      @hidden="htmlContent = null"
    />
  </div>
</template>

<script>
import {
  VBTooltip,
  BSpinner,
  BModal,
  BButton, BCol, BRow, BContainer,
} from "bootstrap-vue";
import PageHeader from "@/views/components/custom/page-header/PageHeader.vue";
import CarteiraVacinacaoTableSimple from '@/views/custom-pages/Vacinacao/components/CarteiraVacinacaoTableSimple.vue';
import CarteiraVacinacaoModal from '@/views/custom-pages/Vacinacao/components/CarteiraVacinacaoModal.vue';

export default {
  title: "Carteira de Vacinação Colaborador",
  components: {
    BContainer,
    BRow,
    BCol,
    PageHeader,
    BSpinner,
    BModal,
    BButton,
    CarteiraVacinacaoTableSimple,
    CarteiraVacinacaoModal,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      linkItems: [
        {
          name: "Registro de Vacinados",
          routeName: "vacinacao-list",
        },
        {
          name: "Carteira de Vacinação Colaborador",
          active: true,
        },
      ],
      loadingData: true,
      filtering: false,
      withoutResults: false,
      showModalView: false,
      loadingModal: false,
      loadingDownload: false,
      htmlContent: null,
      loadingVaccinationCard: {},

      table: {
        fields: [
          {
            key: "colaborador",
            label: "Colaborador",
            sortable: false,
          },
          {
            key: "cpf",
            label: "CPF",
            sortable: false,
          },
          {
            key: "acoes",
            label: "Ações",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          },
        ],
        items: [],
        optionsSize: [10, 25, 50, 100],
      },
    };
  },
  methods: {
    loadColaborador() {
      this.loadingData = true;
      this.filtering = true;

      this.$http.get(this.$api.getColaboradorLogadoCarteiraVacinacao())
        .then(({ data }) => {
          this.table.items[0] = data || [];
          this.withoutResults = this.table.items.length === 0;
        })
        .catch(() => {
          this.table.items = [];
          this.withoutResults = true;
        })
        .finally(() => {
          this.loadingData = false;
          this.filtering = false;
        });
    },

    viewVaccinationCard(colaborador) {
      this.currentColaborador = colaborador;
      this.showModalView = true;
      this.loadingModal = true;
      this.loadingDownload = false;
      this.htmlContent = null;

      const cpf = colaborador.cpf.replace(/\D/g, '');
      this.$http.get(this.$api.acessoPublicoCarteiraHtml(cpf))
          .then(({ data }) => {
            this.htmlContent = typeof data === 'string' ? data : (data.html || data.data || data);
            this.loadingModal = false;
          })
          .catch(() => {
            this.$toast.error("Erro ao carregar a carteira de vacinação, contate o suporte...");
            this.loadingModal = false;
            this.showModalView = false;
          });
    },
    downloadVaccinationCard() {
      if (!this.currentColaborador) {
        return;
      }

      const cpf = this.currentColaborador.cpf.replace(/\D/g, '');
      this.loadingDownload = true;
      this.$toast.success('Gerando Carteira de Vacinação...');

      this.$http.get(this.$api.acessoPublicoCarteiraPdf(cpf), { responseType: 'blob' })
          .then(({ data }) => {
            const blob = new Blob([data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `carteira_de_vacinacao_${cpf}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
            this.$toast.success('Carteira de vacinação gerada com sucesso!');
          })
          .catch(() => {
            this.$toast.error('Erro ao gerar o PDF, tente novamente...');
          })
          .finally(() => {
            this.loadingDownload = false;
          });
    },
    generateVaccinationCard(cpf) {
      const cpfNumerico = cpf.replace(/\D/g, '');
      this.$set(this.loadingVaccinationCard, cpf, true);
      this.$toast.success('Gerando Carteira de Vacinação...');

      this.$http.get(this.$api.acessoPublicoCarteiraPdf(cpfNumerico), { responseType: 'blob' })
          .then(({ data }) => {
            const blob = new Blob([data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `carteira_de_vacinacao_${cpfNumerico}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
            this.$toast.success('Carteira de vacinação gerada com sucesso!');
          })
          .catch(() => {
            this.$toast.error("Erro ao gerar a carteira de vacinação, contate o suporte...");
          })
          .finally(() => {
            this.$set(this.loadingVaccinationCard, cpf, false);
          });
    },
    logout() {
      this.$store.dispatch('publicAccess/logout').finally(() => {
        this.$router.replace({ name: 'public-login' })
      })
    },
  },
  mounted() {
    if (!this.token) {
      this.logout()
      return
    }
    this.loadColaborador();
  },
  computed: {
    token() {
      return this.$store.getters['publicAccess/token']
    },
  },
};
</script>


